import {register} from "swiper/element/bundle";

let registered = false;

/** Registers the Swiper web components once during application bootstrap. */
export function registerSwiperElements(): void {
  if (!registered) {
    register();
    registered = true;
  }
}
